var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-skeleton-loader',{attrs:{"width":_vm.width,"height":_vm.height,"animation":_vm.animation,"rounded":_vm.rounded,"radius":_vm.radius,"type":_vm.type,"color":_vm.color}})}
var staticRenderFns = []

export { render, staticRenderFns }